 import './App.scss';
import * as React from 'react';
import Loader from "./components/Loader/Loader";
import EmailForm from "./pages/EmailForm/EmailForm";
import Main from "./components/Main";

interface Props {
    client: any,
    backend: string,
    origin?: string,
    email?: string,
    consent: string,
    autofocus: boolean
}

interface State {
    email: string;
    loading: boolean
    logged: boolean,
    success?: boolean,
    invalidEmail: boolean,
    invalidEmailReason?: string,
    userStatus?: string
    fields: Array<string>;
    alreadySubscribe: boolean;
    error: boolean

}

export default class AppNewsletter extends React.Component<Props, State> {

    state: State  = {
        email: '',
        loading: true,
        logged: false,
        invalidEmail: false,
        alreadySubscribe: false,
        fields: [],
        error: false,
    };

    componentDidMount() {
        this.props.client
            .checkSession()
            .then((session: any) => {
                fetch(
                    this.props.backend + '/api/origin/' + this.props.origin + '/user/jwt',
                    {
                        method: 'POST',
                        body: session.idToken,
                        credentials: 'include'
                    }
                )
                    .then(res => res.json())
                    .then((data) => {
                        this.setState({ email: data.email, loading: false });

                      if (data.consents[this.props.consent] !== undefined && data.consents[this.props.consent].granted) {
                        this.setState({ alreadySubscribe: true });
                      }
                    })
            })
            .catch((err: any) => {
                this.setState({loading: false});
            });
    }

    handleEmailSubmit(email: string) {
        this.setState({loading: true});

      var form = new FormData();
      form.append('email', email);

      fetch(this.props.backend + '/api/email/check', {
        method: "POST",
        body: form,
        credentials: 'include'
      })
        .then((res) => {
          if (res.ok) {
            fetch(
              this.props.backend + '/api/origin/' + this.props.origin + '/user/email/' + email.replace('+','%2B') + '/newsletter/' + this.props.consent + '/subscribe',
              {
                method: "POST",
                credentials: 'include'
              })
              .then(res => res.json())
              .then((data) => {
                this.setState({loading: false, success: true});
              })
              .catch(() => {
                this.setState({loading: false, error: true});
              })
          } else {
            this.setState({loading: false, invalidEmail: true })
          }
          return res.json()
        })
        .then((data) => {
          if (data.state && data.state === 'disposable') {
            this.setState({invalidEmailReason: 'Nous n\'acceptons pas les emails jetables, merci d\'utiliser votre email professionnel.'});
          }
        })
    }

    handleLoginOK() {
        // nothing redirect after login will append
    }

    public render() {
        const globalClass = 'gl-newsletter ' + this.props.origin;
        if (this.state.loading) {
            return (
                <Main className={globalClass} title=''>
                    <div className="text-center">
                        <Loader/>
                    </div>
                </Main>
            );
        }

        if (this.state.success) {
            return (
              <Main className={globalClass} title=''>
                <div className="text-center">
                  <p className='larger'>Merci, votre inscription a bien été prise en compte.</p>
                </div>
              </Main>
            );
        }

        if (this.state.alreadySubscribe) {
            return (
              <Main className={globalClass} title=''>
                <div className="text-center">
                  <p className='larger'>Vous êtes déjà inscrit à la newsletter.</p>
                </div>
              </Main>
            );
        }
        
        if (this.state.success === false) {
          console.error('Une erreur s\'est produite avec votre inscription');

          return (
            <Main className={globalClass} title=''>
              <div className="text-center">
                <p className='larger'>Une error est survenue lors de votre inscription.</p>
               </div>
            </Main>
            );
        }

      return (
        <Main className={globalClass} title=''>
          <EmailForm
            email={this.state.email}
            handleSubmit={(email) => this.handleEmailSubmit(email) }
            error={this.state.invalidEmail}
            errorMessage={this.state.invalidEmailReason}
            autofocus={this.props.autofocus}
            submitText="Je m'inscris"
          />
        </Main>
      );
    }


}

